import { render } from "./Imagegallery.vue?vue&type=template&id=520a238a&scoped=true"
import script from "./Imagegallery.vue?vue&type=script&lang=js"
export * from "./Imagegallery.vue?vue&type=script&lang=js"

import "./Imagegallery.vue?vue&type=style&index=0&id=520a238a&scoped=true&lang=css"

import exportComponent from "/Users/hk/Omat tiedostot/koodit/htmljacss/hkvue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-520a238a"]])

export default __exports__